import ajax from '@/resources/myApi';
import vm from '@/main';

export const service = {
  getContacts,
  getByParams,
  setPrimaryContact,
  saveCompanyContactRecord,
  updateCompanyContactRecord,
  getContactNotes,
  deleteContact,
  saveContactNotes,
  deleteContactNote,
  getContactRoleTypes,
  getCompanyBusinessUnitByCompanyId,
  getContactsLookupByCompanyId,
};

async function getContacts(
  companyId,
  pageNumber,
  pageSize,
  sortBy,
  sortOrder,
  filters
) {

  const params = {
    companyId,
    pageNumber,
    pageSize,
    sortOrder,
    sortBy,
    filters
  };

  try {
    const { data } = await ajax.get(`api/contact/forcompany`, {
      name: 'contacts',
      params
    });

    return data;
  } catch (error) {
    if (error.response.status < 500) {
      // company does not exist
      vm.$snotify.error('company not found');
      vm.$router.push({ name: 'company' });
    }
    return {};
  }
}

async function getByParams(
  id,
  pageNumber,
  pageSize,
  sortBy,
  sortOrder,
) {
  const params = {
    pageNumber,
    pageSize,
    sortBy,
    sortOrder,
  };
  try {
    const { data } = await ajax.get(`api/contact/forcompany/${id}`, {
      name: 'Company Contacts',
      params
    });

    return data;
  } catch { }
}

async function setPrimaryContact(contactIds) {
  try {
    // Patching two Ids as one primary location only.
    // First index is for the Old Primary Location, Second Index is for the New Primary Location
    if (contactIds[0] != 0) {
      await ajax.patch(`api/contact/${contactIds[0]}`, {
        name: 'contact old primary',
        body: [
          {
            'value': false,
            'path': '/isPrimary',
            'op': 'replace',
          }
        ],
      });
    }

    await ajax.patch(`api/contact/${contactIds[1]}`, {
      name: 'contact new primary',
      body: [
        {
          'value': true,
          'path': '/isPrimary',
          'op': 'replace',
        }
      ],
    });

    vm.$snotify.success('New Primary Contact has been saved', 'Primary Contact');
  } catch { }
}

async function saveCompanyContactRecord(spObj) {
  try {

    const params = {
      name: 'companycontact save',
      body: {
        vwDto: spObj,
        selectedContactRoles: spObj.selectedContactRoles
      }
    };

    const apiResult = await ajax.post('api/contact/SaveContact', params);

    const apiResponseData = apiResult && apiResult.data;

    if (apiResponseData) {

      for (let i = 0; i < spObj.notesArr.length; i++) {
        await this.saveContactNotes({
          id: apiResponseData.id,
          notes: spObj.notesArr[i].notes
        });
      }

      for (let i = 0; i < spObj.notesDelete.length; i++) {
        if (spObj.notesDelete[i] != null || spObj.notesDelete[i] != undefined)
          await this.deleteContactNote(spObj.notesDelete[i]);
      }

      vm.$snotify.success('Company Contact has been added', 'Company Contact');

    } else {
      vm.$snotify.error(`There was a problem with added Company Contact`);
    }

    return apiResponseData;
  } catch (error) {
    return null;
  }
}

async function updateCompanyContactRecord(spObj) {
  try {

    const params = {
      name: 'companycontact update',
      body: {
        vwDto: spObj,
        selectedContactRoles: spObj.selectedContactRoles
      }
    };

    const apiResult = await ajax.post('api/contact/UpdateContact', params);

    const apiResponseData = apiResult && apiResult.data;

    if (apiResponseData) {
      vm.$snotify.success('Company Contact has been updated', 'Company Contact');
    } else {
      // Show error notification
      vm.$snotify.error(`There was a problem with update Company Contact`);
    }

    return apiResponseData;
  } catch (error) {
    return null
  }
}

async function getContactNotes(id) {
  try {
    const { data } = await ajax.get(`api/ContactNote/ByContactId/${id}`, {
      name: 'company contact notes',
      sortBy: 'dateCreated'
    });

    return data;
  } catch (error) {
    if (error.response.status < 500) {
      // company does not exist
      vm.$snotify.error('contact not found');
      vm.$router.push({ name: 'Contact' });
    }
    return {};
  }
}

async function deleteContact(id) {
  try {
    const { data } = await ajax.delete(`api/contact/${id}`, {
      name: 'company contact delete'
    });

    vm.$snotify.success('Company Contact has been deleted', 'Company Contact');

    return data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

async function saveContactNotes(noteObj) {

  const { data } = await ajax.post('api/contactnote', {
    name: 'contact note save',
    body: {
      contactId: noteObj.id,
      notes: noteObj.notes,
      active: true
    }
  });

  console.log(data, 'Contact Note Save');
  return data;
}

async function deleteContactNote(id) {
  const { data } = await ajax.delete(`api/contactnote/${id}`, {
    name: 'contact note delete',
  });

  return data;
}

async function getContactRoleTypes() {
  try {
    const { data } = await ajax.get(`api/ContactRole/GetContactRoleTypes`);

    return data;

  } catch (error) {
    return {};
  }
}

async function getCompanyBusinessUnitByCompanyId(companyId) {
  try {
    const params = {
      companyId
    };

    const { data } = await ajax.get(`api/CompanyBusinessUnitLookupView/GetCompanyBusinessUnitByCompanyId`,
      { params });

    return data;

  } catch (error) {
    return [];
  }
}

async function getContactsLookupByCompanyId(companyId) {
  try {
    const params = {
      companyId
    };

    const { data } = await ajax.get(`api/ContactsLookupView/GetContactsLookupByCompanyId`,
      { params });

    return data;

  } catch (error) {
    return [];
  }
}

export default service;